import React, { Component } from 'react';
import { withRouter, routerShape } from 'react-router';
import { Button, ButtonToolbar } from 'react-bootstrap';
import JobActions from '../actions/JobActions';
import SavedJobActions from '../actions/SavedJobActions';
import ExporterForm from '../components/ExporterForm.react';
import ExportSpec from '../stores/specs/ExportSpec';
import CurrentOrganizationIdStore from '../stores/CurrentOrganizationIdStore';
import CurrentRoleStore from '../stores/CurrentRoleStore';
import MainPage from '../components/MainPage.react';

class Exporter extends Component {
  static propTypes = {
    router: routerShape,
  }

  constructor(props) {
    super(props);
    this.state = {
      job: new ExportSpec(),
      organizationId: CurrentOrganizationIdStore.getState(),
      canSave: CurrentRoleStore.canSaveJobs(),
    };
    this._onChange = this._onChange.bind(this);
    this.onComplete = this.onComplete.bind(this);
    this.onSave = this.onSave.bind(this);
    this._updateEnteredName = this._updateEnteredName.bind(this);
    this._updateQuery = this._updateQuery.bind(this);
    this._selectDelimiter = this._selectDelimiter.bind(this);
  }

  componentDidMount() {
    this.orgIdSubscription = CurrentOrganizationIdStore.addListener(this._onChange);
    this.roleSubscription = CurrentRoleStore.addListener(this._onChange);
  }

  componentWillUnmount() {
    this.orgIdSubscription.remove();
    this.roleSubscription.remove();
  }

  onSave() {
    SavedJobActions.create(this.state.job.jobName,
      this.state.organizationId, this.state.job.configJson);
  }

  onComplete() {
    JobActions.submitJob(
      this.state.job.jobName,
      this.state.organizationId,
    this.state.job.configJson).then((jobResult) => {
      this.props.router.push(`/jobs/${jobResult.id}`);
    }).catch((e) => {
      console.error(e);
    });
  }

  _updateQuery(newQuery) {
    this.setState({ job: this.state.job.set('query', newQuery) });
  }

  _updateEnteredName(newName) {
    this.setState({ job: this.state.job.set('enteredName', newName) });
  }

  _selectDelimiter(delimiter) {
    this.setState({ job: this.state.job.set('delimiter', delimiter) });
  }

  _onChange() {
    this.setState({
      organizationId: CurrentOrganizationIdStore.getState(),
      canSave: CurrentRoleStore.canSaveJobs(),
    });
  }

  render() {
    return (
      <MainPage>
        <h3>BlueLabs Data Exporter</h3>

        <ExporterForm
          name={this.state.job.jobName}
          query={this.state.job.query}
          delimiter={this.state.job.delimiter}
          onNameChange={this._updateEnteredName}
          onDelimiterChange={this._selectDelimiter}
          onQueryChange={this._updateQuery}
        />
        <ButtonToolbar>
          <Button
            bsStyle='primary'
            bsSize='large'
            onClick={this.onComplete}
            disabled={!this.state.job.valid}
          >
            Submit
          </Button>
          {this.state.canSave &&
            <Button
              bsSize='large'
              onClick={this.onSave}
              disabled={!this.state.job.valid}
            >Save
            </Button>
          }
        </ButtonToolbar>
      </MainPage>
    );
  }
}

export default withRouter(Exporter);
